import api from "../api";

const getReels = async (limit = 20) => {
  const res = await api.get("/reels", { params: { limit } });
  return res.data;
};

export { getReels };